import {z} from 'zod';

// Zod schemas
export const GetOnlineOfferSettingsResponseBodySchema = z.object({
  disclaimer: z.string(),
  buyingDisclaimer: z.string(),
});

export const PutOnlineOfferSettingsRequestBodySchema = z.object({
  disclaimer: z.string(),
  buyingDisclaimer: z.string(),
});

export const ExtraOptionsResponseBodySchema = z.object({
  extraOptions: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      description: z.string().optional(),
      price: z.number(),
      enabled: z.boolean(),
    })
  ),
});

export const ExtraOptionsRequestBodySchema = z.object({
  extraOptions: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      description: z.string().optional(),
      price: z.number(),
      enabled: z.boolean(),
    })
  ),
});

// Inferred TypeScript types from Zod schemas
export type GetOnlineOfferSettingsResponseBody = z.infer<
  typeof GetOnlineOfferSettingsResponseBodySchema
>;
export type PutOnlineOfferSettingsRequestBody = z.infer<
  typeof PutOnlineOfferSettingsRequestBodySchema
>;

// API argument and response types
export type GetOnlineOfferSettingsApiResponse =
  /** status 200  */ GetOnlineOfferSettingsResponseBody;
export type PutOnlineOfferSettingsApiArg = {
  onlineOfferSettingsRequestBody: PutOnlineOfferSettingsRequestBody;
};
